"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const phosphor_react_1 = require("phosphor-react");
const getLaravelConfig_1 = __importDefault(require("./getLaravelConfig"));
const animations_1 = require("./animations");
const AuthDenied_1 = require("../../components/Layout/AuthDenied");
const getDefaultConfig = () => (Object.assign({ formatResponse: (resp) => resp.data, icons: {
        CARET_UP: phosphor_react_1.CaretUp,
        CARET_DOWN: phosphor_react_1.CaretDown,
        CHECK: phosphor_react_1.Check,
        SEARCH: phosphor_react_1.MagnifyingGlass,
        FILE: phosphor_react_1.FileDotted,
        SHOW: phosphor_react_1.Eye,
        MENU: phosphor_react_1.List,
        CLOSE: phosphor_react_1.X,
        HIDE: phosphor_react_1.EyeSlash,
    }, authDeniedComponent: AuthDenied_1.AuthDenied, imageOptimizer: true, pageTransitions: true, csrfCookieUrl: '', pageLoader: true, animations: animations_1.animations, authedRoutes: [] }, getLaravelConfig_1.default()));
exports.default = getDefaultConfig;
